import cmsClient from "src/services/cmsClient";

export interface MentionItem {
	id: string;
	label: string;
	subtitle?: string;
}

export const fetchUserMentions = async (
	query: string
): Promise<MentionItem[]> => {
	if (query.trim().length < 1) return [];
	try {
		const res = await cmsClient.get("/socialprofile/search/", {
			params: { search_term: query }
		});
		return (res.data || []).map(
			(u: {
				username: string;
				full_name?: string;
				role?: string;
				user_cms_id?: string;
			}) => ({
				id: u.user_cms_id ?? u.username,
				label: u.full_name || u.username,
				subtitle: u.role ?? ""
			})
		);
	} catch {
		return [];
	}
};

export const fetchHashtagMentions = async (
	query: string
): Promise<MentionItem[]> => {
	if (query.trim().length < 3) return [];
	try {
		const res = await cmsClient.get("/hashtag/", { params: { search: query } });
		// Only offer hashtags with a real uuid — the id is persisted into the
		// backend's `hashtag_ids: List<Guid>`, so a name fallback here would 400
		// the entire save rather than just dropping one tag.
		return (res.data?.results || [])
			.filter((h: { uuid?: string }) => Boolean(h.uuid))
			.map((h: { uuid?: string; name: string; description?: string }) => ({
				id: h.uuid as string,
				label: h.name,
				subtitle: h.description ?? ""
			}));
	} catch {
		return [];
	}
};
